import React from 'react';
import NavigationStepper, {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../../Components/Stepper/NavigationStepper';
import MedicalHistoryConfig from './MedicalHistoryConfig/MedicalHistoryConfig';
import SubTabNavigationStepperItems from '../../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepperItems';

interface Props {
	workplaceId: string;
}

const TreatmentConfig: React.FC<Props> = ({ workplaceId }) => {
	const steps: NavigationStepperItemType[] = [
		{
			name: 'component.treatmentConfig.medicalHistory',
			key: 'medicalHistory',
			component: (params: NavigationStepperComponentParams) => (
				<MedicalHistoryConfig workplaceId={workplaceId} />
			),
		},
	];

	return (
		<NavigationStepper
			steps={steps}
			initialStepPath='medicalHistory'
			canSkip
			renderItems={({ items, activeKey, onChange }) => (
				<SubTabNavigationStepperItems
					items={items}
					activeKey={activeKey}
					onChange={onChange}
				/>
			)}
		/>
	);
};

export default TreatmentConfig;
